import { create } from "zustand";

/**
 * 現在の章・シーン位置・セリフ位置・相棒の表情を保持するストア。セリフ送りごとに更新される。
 *
 * NFR-002 のための規則: 利用側はストア全体ではなくセレクタで必要なプリミティブ値のみを
 * 購読すること（例: `state.lineIndex` のみ等）。
 */
export interface StoryStore {
  readonly chapterId: string | null;
  readonly sceneIndex: number;
  readonly lineIndex: number;
  readonly companionExpression: string;
  readonly setChapterId: (chapterId: string | null) => void;
  readonly setSceneIndex: (sceneIndex: number) => void;
  readonly setLineIndex: (lineIndex: number) => void;
  readonly setCompanionExpression: (expression: string) => void;
}

export const useStoryStore = create<StoryStore>((set) => ({
  chapterId: null,
  sceneIndex: 0,
  lineIndex: 0,
  companionExpression: "neutral",
  setChapterId: (chapterId) => set({ chapterId }),
  setSceneIndex: (sceneIndex) => set({ sceneIndex }),
  setLineIndex: (lineIndex) => set({ lineIndex }),
  setCompanionExpression: (expression) => set({ companionExpression: expression }),
}));
